module.exports = __webpack_public_path__ + "static/media/img-2.714cfaa8.png";